module.exports = __webpack_public_path__ + "img/NL6370763.9bd824c4.svg";